import React, { useEffect, useRef, useState } from "react";
import Accordion from "react-bootstrap/Accordion";
import CloseIcon from "assets/icons/educationVideo/close-education-video.svg";
import "./styles.scss";
import { useTypedSelector } from "store";
import Video from "../Video/Video";
import { ICourse, IVideo } from "types/common";

interface Props {
  courses?: ICourse[];
  videos?: IVideo[];
  onClickCourse?: (val?: number) => void;
  setPlay: (val: boolean) => void;
  play: boolean;
  onClickVideo?: (val?: IVideo["Data"]) => void;
  onCloseVideo?: () => void;
}

const EducationalSidebar = ({
  courses,
  videos,
  onClickCourse,
  onCloseVideo,
  onClickVideo,
  play,
  setPlay
}: Props) => {
  const [activeItem, setActiveItem] = useState<number | null>(null);
  const [activeVideo, setActiveVideo] = useState<number | null>(null);
  const { isMobileVersion } = useTypedSelector((store) => store.user);
  const videoContainerRef = useRef<HTMLDivElement>(null);

  // The inline player can render below the fold, so scroll it into view once
  // it is opened (both portrait and landscape).
  useEffect(() => {
    if (activeVideo === null || !play || !isMobileVersion) return;
    const timer = setTimeout(() => {
      videoContainerRef.current?.scrollIntoView({ behavior: "smooth", block: "center" });
    }, 300);
    return () => clearTimeout(timer);
  }, [activeVideo, play, isMobileVersion]);

  const handleItemClick = (index: number, e: React.MouseEvent) => {
    if (e.target instanceof HTMLElement && e.target.closest(".video-container-mobile")) {
      return;
    }
    if (onClickCourse && courses[index]?.Data?.Id_Course !== videos[0]?.Data?.CourseId) {
      onClickCourse(courses[index]?.Data?.Id_Course);
      setActiveItem(index);
      setActiveVideo(null);
    } else if (activeItem === index) {
      setActiveItem(null);
    } else {
      setActiveItem(index);
    }
  };

  return (
    <div className="EducarionalSidebar-otr">
      <Accordion
        activeKey={activeItem?.toString()}
        className="accordion practice-ul"
        onSelect={(key) => setActiveItem(key ? parseInt(key as string) : null)}>
        {courses &&
          courses.map((val, index) => {
            const isActive = activeItem === index;
            return (
              <Accordion.Item
                eventKey={`${index}`}
                key={`${val?.Data?.CourseTitle}_${val.Data.Id_Course}`}
                className="accordion-item">
                <Accordion.Header onClick={(e) => handleItemClick(index, e)}>
                  <li className={`practice-li ${isActive ? "practice-li-active-mobile" : ""}`}>
                    <p className="practice-link">
                      {val?.Data?.CourseTitle}
                    </p>
                    {isActive && (
                      <img
                        src={CloseIcon}
                        className="education-sidebar-close-icon"
                        onClick={(e) => {
                          e.stopPropagation();
                          setActiveItem(null);
                          setPlay(false);
                          if (onCloseVideo) onCloseVideo();
                        }}
                      />
                    )}
                  </li>
                </Accordion.Header>
                <Accordion.Body>
                  <ul className="practice-ul">
                    {videos[0]?.Data?.CourseId &&
                      videos[0]?.Data?.CourseId === val.Data.Id_Course &&
                      videos.map((videoItem, i) => {
                        const isActiveVideo = activeVideo === i;
                        return (
                          <li key={videoItem.Data.Id} className="video-item-wrapper">
                            <p
                              className={`practice-link practice-li ${
                                isActiveVideo ? "practice-li-active-mobile" : ""
                              }`}
                              onClick={() => {
                                setActiveVideo(i);
                                if (onClickVideo) onClickVideo(videoItem.Data);
                                setPlay(true);
                              }}>
                              {videoItem?.Data?.Title}
                            </p>
                            {isActiveVideo && (
                              <img
                                src={CloseIcon}
                                className="education-sidebar-close-icon"
                                onClick={() => {
                                  setActiveVideo(null);
                                  if (onCloseVideo) onCloseVideo();
                                  setPlay(false);
                                }}
                              />
                            )}
                            {isActiveVideo && isMobileVersion && videoItem.Data.Url && (
                              <div className="video-container-mobile" ref={videoContainerRef}>
                                {videoItem.Data.VideoType === 1 && (
                                  <video
                                    style={{
                                      width: "100%",
                                      height: "100%",
                                      borderRadius: 20
                                    }}
                                    controls
                                    autoPlay
                                    className="video-mobile"
                                    controlsList="nodownload"
                                    key={videoItem.Data.Url}>
                                    <source src={videoItem.Data.Url} type="video/mp4"></source>
                                  </video>
                                )}
                                {videoItem.Data.VideoType !== 1 && (
                                  <Video
                                    key={videoItem.Data.Url}
                                    source={videoItem.Data.Url}
                                    type={videoItem.Data.VideoType}
                                    play={play}
                                  />
                                )}
                              </div>
                            )}
                          </li>
                        );
                      })}
                  </ul>
                </Accordion.Body>
              </Accordion.Item>
            );
          })}
      </Accordion>
    </div>
  );
};

export default EducationalSidebar;
